import api from './api';

/**
 * Servicio para el registro de nuevos estudiantes
 * Endpoints públicos (sin autenticación)
 */

// Obtener niveles educativos disponibles
export const getNiveles = async () => {
  try {
    const response = await api.get('/registro/niveles');
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Obtener cursos por nivel
export const getCursosPorNivel = async (nivel) => {
  try {
    const response = await api.get(`/registro/cursos/${nivel}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Obtener paralelos de un curso
export const getParalelosPorCurso = async (cursoId) => {
  try {
    const response = await api.get(`/registro/cursos/${cursoId}/paralelos`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Validar disponibilidad de cupos en un paralelo
export const validarDisponibilidad = async (paraleloId) => {
  try {
    const response = await api.post('/registro/validar-disponibilidad', {
      paralelo_id: paraleloId
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Obtener todos los datos necesarios para el formulario en una llamada
export const getFormularioDatos = async () => {
  try {
    const response = await api.get('/registro/formulario-datos');
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Registrar nuevo estudiante
export const registrarEstudiante = async (datosEstudiante) => {
  try {
    const response = await api.post('/registro/estudiantes', datosEstudiante);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Cargar documento de estudiante
export const cargarDocumento = async (estudianteId, tipoDocumento, archivo) => {
  try {
    const formData = new FormData();
    formData.append('tipo_documento', tipoDocumento);
    formData.append('archivo', archivo);

    const response = await api.post(
      `/registro/estudiantes/${estudianteId}/documentos`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Obtener documentos de un estudiante
export const obtenerDocumentos = async (estudianteId) => {
  try {
    const response = await api.get(`/registro/estudiantes/${estudianteId}/documentos`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// Obtener tipos de documentos requeridos
export const getTiposDocumentosRequeridos = async () => {
  try {
    const response = await api.get('/registro/tipos-documentos');
    return response.data;
  } catch (error) {
    throw error;
  }
};

export default {
  getNiveles,
  getCursosPorNivel,
  getParalelosPorCurso,
  validarDisponibilidad,
  getFormularioDatos,
  registrarEstudiante,
  cargarDocumento,
  obtenerDocumentos,
  getTiposDocumentosRequeridos
};
